
export const titleize = (str: string): string => (
  str.split('-').map(x => x.charAt(0).toUpperCase().concat(x.substring(1))).join(' ')
);

export const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));

export const arraysEqual = (arrA: any[], arrB: any[]): boolean => {
  if (arrA === arrB) return true;
  if (arrA.length !== arrB.length) return false;
  for (let i = 0; i < arrA.length; i++) {
    if (arrA[i] !== arrB[i]) return false;
  }
  return true;
};

export const randomInt = (max: number) => Math.floor(Math.random() * (max + 1));
